<life-di-nav></life-di-nav>
<lifedi-breadcrumb></lifedi-breadcrumb>

<div *ngIf="user && premium" class="container text-center overflow-hidden">
  <div class="row justify-content-center">
    <div class="col">
      <h1 class="lifedi-color" style="margin: 20px;">
        อัพเกรดสถานะสมาชิก
      </h1>
    </div>
  </div>

  <div class="row justify-content-center">
    <div class="col-lg-6 col-md-8 col-sm-12">
      <div class="text-right" style="color: #060E9F; vertical-align: middle">
        Coin ปัจจุบัน: {{ user.TOKEN_AVALABLE | number }} <img src="../../../../assets/coin.png" alt="token"
          class="m-2" style="width: 20px;">
      </div>
      <mat-card>
        <h1 class="text-center" style="margin: 20px;">
          {{ user.DETAIL_EXCHANG.TOKEN_REQ | number }}
          <img src="../../../../assets/coin.png" alt="token" style="width: 30px; margin: 10px;">
          <img src="../../../../assets/fast-forward.png" alt="" style="width: 30px; margin: 10px;">
          <img src="../../../../assets/crown.png" alt="" style="width: 50px; margin: 0px 12px 7px;">
        </h1>
      </mat-card>
    </div>
  </div>
  <div class="row justify-content-center">
    <div class="col-12">
      <p class="text-center m-4" style="font-size: 20px; line-height: 30px;">
        แลก {{ user.DETAIL_EXCHANG.TOKEN_REQ | number }} Token เพื่ออัพเกรดสถานะสมาชิกเป็น *premium {{
        user.DETAIL_EXCHANG.PREMIUM_RECIVE }} วัน
        (สิ้นสุดสถานะ Premium : {{ user.DETAIL_EXCHANG.EXPIREDATE | dateTime: 'shortNoTime' }})
      </p>
      <p class="text-center text-muted m-2">
        *สถานะ premiun สามารถลดราคาการซื้อคอร์สเรียนและสมัครเข้าร่วมกิจกรรมต่างๆในเว็บ Life Di ได้
      </p>

      <div *ngIf="!premium.IS_PREMIUM">
        <div *ngIf="user.TOKEN_AVALABLE >= user.DETAIL_EXCHANG.TOKEN_REQ">
          <lifedi-btn lable="อัพเกรดสถานะสมาชิก" (click)="upgrade()"
            customStyle="color: #fff; background-color: #414A6B; height: 50px;">
          </lifedi-btn>
        </div>
        <div *ngIf="user.TOKEN_AVALABLE < user.DETAIL_EXCHANG.TOKEN_REQ">
          <p class="text-danger">
            Coin ไม่เพียงพอ
          </p>
          <lifedi-btn lable="อัพเกรดสถานะสมาชิก" customStyle="color: #fff; height: 50px;" disabled="true">
          </lifedi-btn>
        </div>
      </div>
      <div *ngIf="premium.IS_PREMIUM"></div>
    </div>
  </div>
</div>
